/**
 * Clinical Observations Data Points
 * Category: Observations
 */

export const observationsDataPoints = [
  // Pulse
  {
    id: 'pulse',
    label: 'Pulse',
    category: 'Observations',
    subcategory: 'Vital Signs',
    fieldType: 'text',
    isActive: true,
    options: [],
    default: '',
    inputConfig: {
      inputType: 'numeric',
      multiSelect: false,
      allowOther: false,
      required: false,
      defaultValue: '',
      placeholder: 'Enter pulse rate (bpm)',
      helpText: 'Heart rate in beats per minute'
    },
    code: '78564009', // SNOMED CT - Pulse rate
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Blood Pressure
  {
    id: 'blood_pressure',
    label: 'BP',
    category: 'Observations',
    subcategory: 'Vital Signs',
    fieldType: 'text',
    isActive: true,
    options: [],
    default: '',
    inputConfig: {
      inputType: 'text',
      multiSelect: false,
      allowOther: false,
      required: false,
      defaultValue: '',
      placeholder: 'Enter BP (e.g., 120/80)',
      helpText: 'Blood pressure in mmHg (systolic/diastolic)'
    },
    code: '75367002', // SNOMED CT - Blood pressure
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Temperature
  {
    id: 'temperature',
    label: 'Temperature',
    category: 'Observations',
    subcategory: 'Vital Signs',
    fieldType: 'text',
    isActive: true,
    options: [],
    default: '',
    inputConfig: {
      inputType: 'numeric',
      multiSelect: false,
      allowOther: false,
      required: false,
      defaultValue: '',
      placeholder: 'Enter temperature (°C)',
      helpText: 'Body temperature in degrees Celsius'
    },
    code: '386725007', // SNOMED CT - Body temperature
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Hemoglobin
  {
    id: 'hemoglobin',
    label: 'Hb',
    category: 'Observations',
    subcategory: 'Laboratory Values',
    fieldType: 'text',
    isActive: true,
    options: [],
    default: '',
    inputConfig: {
      inputType: 'numeric',
      multiSelect: false,
      allowOther: false,
      required: false,
      defaultValue: '',
      placeholder: 'Enter Hb level (g/dl)',
      helpText: 'Hemoglobin level in grams per deciliter'
    },
    code: '38082009', // SNOMED CT - Hemoglobin
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // HGT (Blood Glucose Test)
  {
    id: 'hgt',
    label: 'HGT',
    category: 'Observations',
    subcategory: 'Laboratory Values',
    fieldType: 'text',
    isActive: true,
    options: [],
    default: '',
    inputConfig: {
      inputType: 'numeric',
      multiSelect: false,
      allowOther: false,
      required: false,
      defaultValue: '',
      placeholder: 'Enter HGT (mmol/L)',
      helpText: 'Blood glucose level in millimoles per liter'
    },
    code: '33747003', // SNOMED CT - Blood glucose
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Weight
  {
    id: 'weight',
    label: 'Weight',
    category: 'Observations',
    subcategory: 'Physical Measurements',
    fieldType: 'text',
    isActive: true,
    options: [],
    default: '',
    inputConfig: {
      inputType: 'numeric',
      multiSelect: false,
      allowOther: false,
      required: false,
      defaultValue: '',
      placeholder: 'Enter weight (kg)',
      helpText: 'Patient weight in kilograms'
    },
    code: '27113001', // SNOMED CT - Body weight
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Breathing Rate
  {
    id: 'breathing_rate',
    label: 'Breathing rate',
    category: 'Observations',
    subcategory: 'Vital Signs',
    fieldType: 'text',
    isActive: true,
    options: [],
    default: '',
    inputConfig: {
      inputType: 'numeric',
      multiSelect: false,
      allowOther: false,
      required: false,
      defaultValue: '',
      placeholder: 'Enter breathing rate (per min)',
      helpText: 'Respiratory rate per minute'
    },
    code: '86290005', // SNOMED CT - Respiratory rate
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Pain Scale
  {
    id: 'pain_scale',
    label: 'Pain',
    category: 'Observations',
    subcategory: 'Assessment Scales',
    fieldType: 'text',
    isActive: true,
    options: [],
    default: '',
    inputConfig: {
      inputType: 'numeric',
      multiSelect: false,
      allowOther: false,
      required: false,
      defaultValue: '',
      placeholder: 'Enter pain score (0-10)',
      helpText: 'Pain scale from 0 (no pain) to 10 (severe pain)'
    },
    code: '225908003', // SNOMED CT - Pain score
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
]
